import countryNameDictionary from "@/assets/js/countryNameDictionary.js";
export const sameDomain = url => {
  if (url) {
    return url.indexOf(location.host) > -1 || url.indexOf("http") < 0 || false;
  }
  return true;
};
export const notPDF = url => {
  if (url) {
    return !url || url.indexOf("pdf") < 0;
  }
  return true;
};

export const fetchCountryName = cc => {
  // console.log("fetchCountryName << ", countryNameDictionary, " :: ", cc);
  // console.log("country name ==  ", countryNameDictionary[cc]);
  return countryNameDictionary[cc];
};
/*
  return query object from query string
*/
export const stringToQuery = _string => {
  if (!_string) {
    return "";
  }
  let query = {},
    p = new URLSearchParams(_string);
  if (p.toString()) {
    p.forEach((val, key) => {
      query[key] = val;
    });
    return query;
  } else {
    return "";
  }
};

export const toDateObj = date => {
  if (date) {
    let validDateString;
    if (typeof date === "string") {
      let split = date.split("/");
      if (split.length) {
        // HOPEFULLY DD/MM/YYYY
        validDateString = `${split[2]}-${split[1]}-${split[0]}`;
      }
      return new Date(validDateString);
    }
    return new Date(date);
  }
  return null;
};

export const toDateNoTimezone = date => {
  let _date = new Date(date);
  if (_.isDate(_date)) {
    let tz = _date.getTimezoneOffset() * 60000;
    return new Date(_date.getTime() - tz).setHours(0, 0, 0, 0);
  }
  return null;
};

export const isIE = function() {
  var ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object
  var msie = ua.indexOf("MSIE "); // IE 10 or older
  var trident = ua.indexOf("Trident/"); //IE 11
  // console.log("ua > ", ua);
  return msie > 0 || trident > 0;
};

export const subdomain = function() {
  return APP_CONFIG.APP_NAME;
  //return "patient";
  //return "lab";
  var subdomain =  window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false;    
  if(subdomain=='www'){
    subdomain='';
  }
  return subdomain; 
};

/*
  For catalog rendering mainly...
*/
export const hasDimensions = item => {
  return (
    item.diameter || item.gingival_height || item.crown_height || item.length
  );
};
export const parseDimensions = (item, localize) => {
  let dimensions = [];
  if (item.diameter) {
    dimensions.push(
      `<i class="sym">${localize("diameter_sign")}</i>${item.diameter +
        localize("mm")}`
    );
  }
  if (item.gingival_height) {
    dimensions.push(`${localize("h") + item.gingival_height + localize("mm")}`);
  }
  if (item.crown_height) {
    dimensions.push(`${localize("c") + item.crown_height + localize("mm")}`);
  }
  if (item.length) {
    dimensions.push(`${localize("l") + item.length + localize("mm")}`);
  }
  return dimensions.join(`, `);
};

export const parseToString = value => {
  if (typeof value === "object") {
    return value.join(", ");
  }
  return value;
};

/*
    FETCH 
    Fetch content from cache then server
*/
export const fetchContent = async function(
  _id,
  _key,
  vm,
  state,
  commit,
  mutation,
  api,
  apiHeaders,
  apiOptions
) {

  // active cache?
  let useCache = vm.$useCache[_key];

  // locale keys
  let ln, cc;
  ({ ln, cc } = state.locale);

  // Add locale to headers
  let storageKey = `routedata_${_key}_${_id}_${cc}${cc ? "-" : ""}${ln}`;
  let dataVersion = -1;
  let json;
  let _data;

  //if(_id.indexOf('HomeV3')==-1)//ignore cache if loading home v3 data
  //{
    _data = storage.get(storageKey);
    if (_data) {
      json = JSON.parse(_data);
      dataVersion = json.version;
      if (mutation) {
        commit(mutation, json);
      }
    }    
  //}

  //HomeV3/global
  // console.log("fetch data from cache >> ", storageKey, " :::: ", _data);

  /*
  After content has loaded from cache
  If an API has been passed (i.e menu doesn't need to call server (data recieved from rawitems))
  check server to see if there's an updated
  version of the data.
  */
  if (api) 
  {
    let Test_mode = "off";
    let Test_layout = "";
    let isTestSession = sessionStorage.getItem("_isInTestMode");
    if (isTestSession === null) {
      Test_mode = "off";
    }else{
      Test_mode = "on";
      if(_id==5635){
        Test_layout="product-info-v2";//lynx          
      }
    }  
    ////alert("Test_mode="+Test_mode);

    /*
    if(
      location.href.indexOf("http://localhost:8080") != -1 ||
      location.href.indexOf("https://test1.mis-implants.com") != -1){
        Test_mode = "on";
        if(_id==5635)
        {
          Test_layout="product-info-v2";//lynx          
        }
    }
    */
 
    let headers = Object.assign({ ln, cc ,Test_mode,Test_layout}, apiHeaders);

    return fetchContentFromServer(
      dataVersion,
      storageKey,
      api,
      headers,
      apiOptions,
      mutation,
      commit,
      useCache
    ).then(res => {
      return res;
    });
  }
  
  if (!_data && !api) {
    // i.e first time loading menu...
    return { noData: true, useCache, storageKey };
  }
};
const fetchContentFromServer = async function(
  version,
  storageKey,
  api,
  headers,
  apiOptions,
  mutation,
  commit,
  cache
) {
  
  //alert("headers="+headers);
  console.log("$$$ apiOptions = " + apiOptions);

  let options = apiOptions
    ? Object.assign({ headers }, apiOptions)
    : { headers };
  // console.log("API >> ", api);
  // console.log("OPTIONS >> ", options);
  //options.headers.append('test_mode', 'on');

  return fetch(api, options)
    .then(function(response) {
      // console.log("respons >> ", response);
      if (response.status !== 200) {
        throw new Error("Something Went Wrong!");
      }
      return response.json();
    })
    .then(function(json) {  

      // console.log("json.version >> ", json.version, " ?? ", version);
      /*if (json.version !== version)
            {
              cache && storage.set(storageKey, JSON.stringify(json));
              mutation && commit(mutation, json);
            }
      */
      
            //alert("storageKey:"+storageKey);
            //storageKey:routedata_pageByPath_HomeV3/global_en

      var forceServerData = false;
      if(storageKey && storageKey.indexOf("HomeV3")>-1){
        //forceServerData=true;
      }
      if(forceServerData){
        commit(mutation, json);
      }else{
        if (json.version !== version)
        {
          cache && storage.set(storageKey, JSON.stringify(json));//<<<<<if new homepage data then set expirationDate for 1 day
          mutation && commit(mutation, json);
        }
      }
      return json;
    })
    .catch(function(err) {
      mutation && commit(mutation, err);
      return err;
    });
  // console.log("data fetched >> ", result, " VERSION: ", version);
  // return result;
};

/*
    STORAGE 
    CHECK SUPPORT
*/
function storageSupport() {
  try {
    return "sessionStorage" in window && window["sessionStorage"] !== null;
  } catch (e) {
    return false;
  }
}


export const createToken = length => {
  var a = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890".split("");
  var b = [];  
  for (var i=0; i<length; i++) {
      var j = (Math.random() * (a.length-1)).toFixed(0);
      b[i] = a[j];
  }
  return b.join("");
};



// FETCH FROM STORAGE
/*
  For now all storage will use SESSION,
  unless we choose otherwise
*/
function getFromStorage(key, storageType = sessionStorage) {
  if (storageSupport()) {
    return storageType.getItem(key);
  }
  return null;
}
// SAVE TO STORAGE
function setToStorage(key, data, storageType = sessionStorage) {
  typeof data !== "string" && (data = JSON.stringify(data));
  storageSupport() && storageType.setItem(key, data);
}

export const setToLocalStorage = function(key, data)
{
  localStorage.setItem(key, data);
}

export const splitWords = function(delay,conElement,css1,css2)
{
  //splitWords(this.startDelay,1,contentEl,'splLine','splLineText',);
}

export const splitLines = function(splitElement,customeRowClass)
{
  //split text to words
  var p = splitElement;//document.getElementsByClassName('split-text')[0];
  p.innerHTML = p.innerText.split(/\s/).map(function(word) {
    return '<span>' + word + '</span>'
  }).join(' ');

  //get lines  
  var lines = [];
  var line;
  var words = p.getElementsByTagName('span');
  var lastTop;
  for (var i = 0; i < words.length; i++) {
    var word = words[i];
    if (word.offsetTop != lastTop) {
      lastTop = word.offsetTop;
      line = [];
      lines.push(line);
    }
    line.push(word);
  }

  var splittedText = "";
  for (var lineIndex = 0; lineIndex < lines.length; lineIndex++) {
    var lineText = "";
    for (var wordIndex = 0; wordIndex < lines[lineIndex].length; wordIndex++) {
      lineText=lineText+lines[lineIndex][wordIndex].innerText+' ';
    }    

    let rowClasses = "xLineText";
    if(customeRowClass!=undefined && customeRowClass.length>0)
    {
      rowClasses=rowClasses+" "+customeRowClass;
    }
    //console.log("line="+lineText);//[0][0].innerText);
    splittedText = splittedText +
    "<div class='xLine' style='--index:"+lineIndex+"'><div class='"+rowClasses+"' style='--line_index:"+lineIndex+"'>"+lineText+"</div></div>";
  }
  p.innerHTML = splittedText;

  

}



// CHECK EXPIRATION
// function checkStorageExpiration(storageType, key) {
//   let curdate = new Date(),
//     date = new Date(storageType.getItem(key + "_expiration"));
//   if (!!date && curdate > date) {
//     removeFromStorage(storageType, key);
//     return true;
//   }
//   return false;
// }
// SET EXPIRATION
// function setStorageExpiration(storageType, key, days = 10) {
//   let expiredate = new Date();
//   expiredate.setDate(expiredate.getDate() + days);
//   storageType.setItem(key + "_expiration", expiredate);
// }

// REMOVE FROM STORAGE
function removeFromStorage(key, storageType = sessionStorage) {
  storageType.removeItem(key);
  // storageType.removeItem(key + "_expiration");
}

// RESTART CACHING
// function clearCache() {
//   // removeFromStorage(localStorage, "_marketcategories");
//   // removeFromStorage(sessionStorage, "_filtersUI");
//   localStorage.clear();
//   sessionStorage.clear();
// }

export const storage = {
  support: storageSupport,
  get: getFromStorage,
  set: setToStorage,
  remove: removeFromStorage
};

export const isMobileScreen = function()
{

  let w = document.documentElement.clientWidth || window.innerWidth,
    h = document.documentElement.clientHeight || window.innerHeight;
    //alert("w="+w+" h="+h); //w 390 / h 844
    //w 1440 / h 800
    let isM = (w < h && w < 813);// || (h < w && h < 813);
    //alert("isMobileScreen="+isM);
  return isM;
}
